import { useState } from "react";

import { useTheme } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";
import Button from "ui/base/Button";


More.Item = ({ icon, size, color, children, ...props }) => {
	const style = {
		root: {
			gap: 0.5
		}
	};
	return (
		<MenuItem {...props} sx={{ ...style.root, ...props.sx }}>
			{icon && <Icon name={icon} size={size} color={color} />}
			{children}
		</MenuItem>
	);
};

export default function More({ children }) {
	const [anchor, setAnchor] = useState(null);
	const open = Boolean(anchor);
	const theme = useTheme();
	const close = () => setAnchor(null);

	return (
		<Box>
			<Button.Icon icon="ellipsis-vertical" color={theme.palette.text.secondary} onClick={(e) => setAnchor(e.currentTarget)} />
			<Menu anchorEl={anchor} open={open} onClose={close} onClick={close}>
				{children}
			</Menu>
		</Box>
	);
}